import {
  createBrowserRouter,
  RouterProvider,
  Navigate
} from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import PrivateRoute from '@/components/common/PrivateRoute'
import Login from '@/pages/Login'
import Home from '@/pages/Home'
import EventDetail from '@/pages/EventDetail'
import EventLive from '@/pages/EventLive'

const router = createBrowserRouter(
  [
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/',
    element: (
      <PrivateRoute>
        <Home />
      </PrivateRoute>
    )
  },
  {
    path: '/events/:id',
    element: (
      <PrivateRoute>
        <EventDetail />
      </PrivateRoute>
    )
  },
  {
    path: '/events/:id/live',
    element: (
      <PrivateRoute>
        <EventLive />
      </PrivateRoute>
    )
  },
  {
    path: '*',
    element: <Navigate to="/" replace />
  }
])

function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  )
}

export default App